// Get List CineMa
export const getAllCinemaRequest = "GET_ALL_CINEMA_REQUEST";
export const getAllCinemaSuccess = "GET_ALL_CINEMA_SUCCESS";
export const getAllCinemaFail = "GET_ALL_CINEMA_FAIL";
// Get movie of cinema
export const getShowtimesRequest = "GET_SHOW_TIME_REQUEST";
export const getShowtimesSuccess = "GET_SHOW_TIME_SUCCESS";
export const getShowtimesFail = "GET_SHOW_TIME_FAIL";
// LAY DANH SACH PHONG VE
export const getCinemaRequest = "GET_CINEMA_REQUEST";
export const getCinemaSuccess = "GET_CINEMA_SUCCESS";
export const getCinemaFail = "GET_CINEMA_FAIL";

// TAO LICH CHIEU
export const createShowTimesRequest = "CREATE_SHOW_TIMES_REQUEST";
export const createShowTimesSuccess = "CREATE_SHOW_TIMES_SUCCESS";
export const createShowTimesFail = "CREATE_SHOW_TIMES_FAIL";
